module.exports = __webpack_public_path__ + "img/arrow_up.b18991ed.svg";